import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { Header2 } from '../utils/Header'

import { MARKETING } from '../../utils/constants'

const ListItem = ({ level }) => {
  return MARKETING.points[level].map((item, i) => (
    <div key={i} className="text-lg ">
      <FontAwesomeIcon icon={faCheck} className="mr-2 text-green-500" />
      {item}
    </div>
  ))
}

const Upgrade = () => {
  return (
    <div>
      <Header2>Premium Membership</Header2>
      <div className="flex items-center justify-around">
        <div className="text-5xl font-semibold tracking-wider">$30</div>
        <div className="">
          <ListItem level="premium" />
        </div>
      </div>
    </div>
  )
}

export default Upgrade
